export enum CaseTabsEnum {
  activity = "activity",
  benefit = "benefit",
  severance = "severance",
  documents = "documents",
  insurance = "insurance",
  contact = "contact",
  data = "data",
}
